import { configureStore } from '@reduxjs/toolkit';

import { setupListeners } from '@reduxjs/toolkit/query';
import { exercisesApi } from './api/exercisesAPI';
import { exercisesConfigApi } from './api/exerciseConfigAPI';
import { translationsApi } from './api/translationsAPI';
import { programsApi } from './api/programsAPI';
import { trainingsApi } from './api/trainingsAPI';
import { aclApi } from './api/aclApi';
import { communitiesApi } from './api/communitiesApi';
import { postsApi } from './api/postsApi';
import { chatsApi } from './api/chatsApi';
import { rolesApi } from './api/rolesApi';
import { usersApi } from './api/usersApi';
import { subscriptionsApi } from './api/subscriptionsApi';
import { paymentApi } from './api/paymentsApi';
import { searchApi } from './api/searchApi';
import { languagesApi } from './api/languagesAPI';
import { firebaseApi } from './api/fireBaseStorageApi';
import { bugReportApi } from './api/bugReportApi';
import { appConfigApi } from './api/appConfigApi';
import { syncApi } from './api/syncApi';
import { aiAdminApi } from './api/aiAdminAPI';
import { agreementsApi } from './api/agreementsApi';
import { notificationsAdminApi } from './api/notificationsAdminApi';
import { supportAdminApi } from './api/supportAdminApi';
import { analyticsAdminApi } from './api/analyticsAdminApi';
import { trainingActivityTypesApi } from './api/trainingActivityTypesApi';

export const store = configureStore({
  reducer: {
    [bugReportApi.reducerPath]: bugReportApi.reducer,
    [exercisesApi.reducerPath]: exercisesApi.reducer,
    [exercisesConfigApi.reducerPath]: exercisesConfigApi.reducer,
    [translationsApi.reducerPath]: translationsApi.reducer,
    [languagesApi.reducerPath]: languagesApi.reducer,
    [programsApi.reducerPath]: programsApi.reducer,
    [trainingsApi.reducerPath]: trainingsApi.reducer,
    [aclApi.reducerPath]: aclApi.reducer,
    [communitiesApi.reducerPath]: communitiesApi.reducer,
    [postsApi.reducerPath]: postsApi.reducer,
    [chatsApi.reducerPath]: chatsApi.reducer,
    [rolesApi.reducerPath]: rolesApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [subscriptionsApi.reducerPath]: subscriptionsApi.reducer,
    [paymentApi.reducerPath]: paymentApi.reducer,
    [searchApi.reducerPath]: searchApi.reducer,
    [firebaseApi.reducerPath]: firebaseApi.reducer,
    [appConfigApi.reducerPath]: appConfigApi.reducer,
    [syncApi.reducerPath]: syncApi.reducer,
    [aiAdminApi.reducerPath]: aiAdminApi.reducer,
    [agreementsApi.reducerPath]: agreementsApi.reducer,
    [notificationsAdminApi.reducerPath]: notificationsAdminApi.reducer,
    [supportAdminApi.reducerPath]: supportAdminApi.reducer,
    [analyticsAdminApi.reducerPath]: analyticsAdminApi.reducer,
    [trainingActivityTypesApi.reducerPath]: trainingActivityTypesApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(
      bugReportApi.middleware,
      exercisesApi.middleware,
      exercisesConfigApi.middleware,
      translationsApi.middleware,
      languagesApi.middleware,
      programsApi.middleware,
      trainingsApi.middleware,
      aclApi.middleware,
      communitiesApi.middleware,
      postsApi.middleware,
      chatsApi.middleware,
      rolesApi.middleware,
      usersApi.middleware,
      subscriptionsApi.middleware,
      paymentApi.middleware,
      searchApi.middleware,
      firebaseApi.middleware,
      appConfigApi.middleware,
      syncApi.middleware,
      aiAdminApi.middleware,
      agreementsApi.middleware,
      notificationsAdminApi.middleware,
      supportAdminApi.middleware,
      analyticsAdminApi.middleware,
      trainingActivityTypesApi.middleware,
    ),
});

export function resetState() {}

setupListeners(store.dispatch);
